"use client"

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import { cn } from '@/lib/utils'
import {
    Sword,
    Car,
    Trophy,
    Gamepad,
    Crosshair,
    Rocket,
    Skull,
    Ghost,
    Dice5,
    Footprints,
    Bomb,
    Swords
} from 'lucide-react'
import React from 'react'


interface Category {
    title: string;
    icon: React.ReactNode;
    count: number;
}

const categories: Category[] = [
    {
        title: "اکشن",
        icon: <Sword className="w-5 h-5" />,
        count: 450
    },
    {
        title: "مسابقه‌ای",
        icon: <Car className="w-5 h-5" />,
        count: 185
    },
    {
        title: "ورزشی",
        icon: <Trophy className="w-5 h-5" />,
        count: 245
    },
    {
        title: "ماجراجویی",
        icon: <Gamepad className="w-5 h-5" />,
        count: 360
    },
    {
        title: "تیراندازی",
        icon: <Crosshair className="w-5 h-5" />,
        count: 275
    },
    {
        title: "علمی تخیلی",
        icon: <Rocket className="w-5 h-5" />,
        count: 130
    },
    {
        title: "نقش‌آفرینی",
        icon: <Ghost className="w-5 h-5" />,
        count: 295
    },
    {
        title: "ترسناک",
        icon: <Skull className="w-5 h-5" />,
        count: 110
    },
    {
        title: "استراتژی",
        icon: <Dice5 className="w-5 h-5" />,
        count: 150
    },
    {
        title: "پلتفرمر",
        icon: <Footprints className="w-5 h-5" />,
        count: 180
    },
    {
        title: "بتل رویال",
        icon: <Bomb className="w-5 h-5" />,
        count: 140
    },
    {
        title: "مبارزه‌ای",
        icon: <Swords className="w-5 h-5" />,
        count: 200
    }
];

export default function QuickPopularCategories() {
    return (

        <div className="relative w-full px-5 md:px-0">
            <Swiper
                loop={true}
                grabCursor={true}
                autoplay={{
                    delay: 2500,
                    pauseOnMouseEnter: true
                }}
                breakpoints={{
                    0: {
                        slidesPerView: 5,
                        spaceBetween: 2,
                    },
                    640: {
                        slidesPerView: 6,
                        spaceBetween: 0,
                    },
                    768: {
                        slidesPerView: 9,
                        spaceBetween: 0,
                    },
                    1024: {
                        slidesPerView: 12,
                        spaceBetween: 0,
                    }
                }}
                modules={[Autoplay]}
            >
                {categories.map((category) => (
                    <SwiperSlide key={category.title}>
                        <div className={cn(
                            "group relative flex flex-col items-center justify-center p-2.5",
                            "rounded-2xl transition-all duration-300",
                            "hover:bg-card hover:backdrop-blur-sm",
                            "border border-transparent",
                            "cursor-pointer"
                        )}>
                            <div className={cn(
                                "w-12 h-12 rounded-xl flex items-center justify-center mb-2.5",
                                "bg-card/20 transition-all duration-300",
                                "border border-border/30",
                                "group-hover:border-primary group-hover:bg-card",
                                "group-hover:shadow-[0_0_12px_-3px] group-hover:shadow-primary/30",
                                "relative after:absolute after:inset-0",
                                "after:rounded-xl after:transition-colors",
                                "after:border after:border-transparent",
                                "group-hover:after:border-primary"
                            )}>
                                <div className="text-muted-foreground/80 group-hover:text-primary transition-colors relative z-10">
                                    {category.icon}
                                </div>
                            </div>
                            <h3 className="text-xs text-foreground/90 text-center leading-5 mb-0.5 transition-colors group-hover:text-primary">
                                {category.title}
                            </h3>
                            <span className="text-[10px] text-muted-foreground/70 transition-colors group-hover:text-muted-foreground">
                                {category.count.toLocaleString('fa-IR')} بازی
                            </span>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
} 